export default __webpack_public_path__ + "static/media/50n.44937565.svg";